<div>{{ "Selfservice.AuthenticationBoxTitle" | translate }}</div>
@if (selfServiceStarted()) {
  <div class="green">{{ "Selfservice.AuthenticationBoxText" | translate }} {{ tokenValidFor() | formatduration }}</div>
} @else {
  <div class="red">-</div>
}
